export default __webpack_public_path__ + "fonts/upside-down.svg";